import { useState, useEffect, Suspense } from "react";

import { connect } from "react-redux";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

const ConfigurationADROrigin = props => {
  const [list, setList] = useState([]);

  useEffect(() => {
    props.setObj(16, props.currentRoute, props.currentRoute);

    (async () => {
      const listResponse = await axios.get(`${URL.api}adr/origins/list`, {
        headers: { authorization: `Bearer ${props.user.token}` }
      });

      const parsedData = listResponse.data.data;
      setList(parsedData);
    })();
  }, []);

  const insertAction = () => {
    props.history.push("/adr/origins/create");
  };

  const editAction = row => {
    props.history.push(`/adr/origins/create/${row.id}`);
  };

  const parseStatus = status => (status ? "Ativo" : "Desativado");

  return (
    <>
      <Breadcrumb current={props.currentRoute} />
      <div className="animated fadeIn">
        <Suspense fallback={<Loading />}>
          <Row>
            <div id="list">
              <DataTable
                list={list.map(item => ({
                  ...item,
                  is_active: parseStatus(item.is_active)
                }))}
                path="/adr/origins/create/"
                title="Configuração de Origens ADR"
                header={[
                  { name: "id", denomination: "ID" },
                  { name: "name", denomination: "Nome" },
                  { name: "year", denomination: "Ano" },
                  { name: "is_active", denomination: "Status" },
                  { name: "group_id", denomination: "Grupo" }
                ]}
                insert
                action
                btnEdit
                insertAction={insertAction}
                editAction={editAction}
              />
            </div>
          </Row>
        </Suspense>
      </div>
      <ProtectedRoute routeId={props.currentRoute} />
    </>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfigurationADROrigin);
